var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.background ? 'pro-tip-box' : '']},[_c('h5',{staticClass:"font-weight-bold p-0 "},[_vm._t("header",[_vm._v(" Tips til opskriften ")])],2),_c('hr'),_vm._t("body")],2)}
var staticRenderFns = []

export { render, staticRenderFns }